const niches = {
  Anime: 'anime',
  Apps: 'apps',
  Beauty: 'beauty',
  Business: 'business',
  Catalog: 'catalog',
  Entertainment: 'entertainment',
  Finance: 'finance',
  Games: 'games',
  Health: 'health',
  Jobs: 'jobs',
  Lifestyle: 'lifestyle',
  Misc: 'misc',
  News: 'news',
  Review: 'review',
  Sport: 'sport',
  Tech: 'tech',
  Travel: 'travel',
};

const getNicheValue = (label) => {
  return niches[label];
};

const getNicheLabel = (value) => {
  return Object.keys(niches).find(v => niches[v] === value);
};

export { niches, getNicheValue, getNicheLabel };
